import { render } from "./ProfileTrainingSnapshot.vue?vue&type=template&id=65b03b70&scoped=true"
import script from "./ProfileTrainingSnapshot.vue?vue&type=script&lang=js"
export * from "./ProfileTrainingSnapshot.vue?vue&type=script&lang=js"

import "./ProfileTrainingSnapshot.vue?vue&type=style&index=0&id=65b03b70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b03b70"]])

export default __exports__